var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4465_901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34531 1.34531 0 3 0H10.5V6C10.5 6.82969 11.1703 7.5 12 7.5H18V9.30938C14.5359 10.2891 12 13.4719 12 17.25C12 20.0203 13.3641 22.4672 15.4547 23.9672C15.3047 23.9906 15.1547 24 15 24H3C1.34531 24 0 22.6547 0 21V3ZM18 6H12V0L18 6ZM20.25 10.5C22.0402 10.5 23.7571 11.2112 25.023 12.477C26.2888 13.7429 27 15.4598 27 17.25C27 19.0402 26.2888 20.7571 25.023 22.023C23.7571 23.2888 22.0402 24 20.25 24C18.4598 24 16.7429 23.2888 15.477 22.023C14.2112 20.7571 13.5 19.0402 13.5 17.25C13.5 15.4598 14.2112 13.7429 15.477 12.477C16.7429 11.2112 18.4598 10.5 20.25 10.5ZM21 14.25C21 13.8375 20.6625 13.5 20.25 13.5C19.8375 13.5 19.5 13.8375 19.5 14.25V16.5H17.25C16.8375 16.5 16.5 16.8375 16.5 17.25C16.5 17.6625 16.8375 18 17.25 18H19.5V20.25C19.5 20.6625 19.8375 21 20.25 21C20.6625 21 21 20.6625 21 20.25V18H23.25C23.6625 18 24 17.6625 24 17.25C24 16.8375 23.6625 16.5 23.25 16.5H21V14.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4465_901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.e5a8961bf94af3f5a3ba2393bf416ab2.svg";
export { ForwardRef as ReactComponent };